/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getRlsOrgAnalytics = /* GraphQL */ `
  query GetRlsOrgAnalytics($customerId: String!, $date: AWSDate!) {
    getRlsOrgAnalytics(customerId: $customerId, date: $date) {
      id
      customerId
      date
      time
      organizationId
      organizationFriendlyId
      environmentCode
      activeUsers
      inActiveUsers
      deletedUsers
      roles
      apiConnections
      customerCodes
      trustedApis
      trustedObjects
      apiResources
      objects
      categories
      schedulers
      dataSyncStatus
      environment

      __typename
    }
  }
`;

export const getRlsOrgAnalyticsExternalIntegrationsOnly = /* GraphQL */ `
  query GetRlsOrgAnalytics($customerId: String!, $date: AWSDate!) {
    getRlsOrgAnalytics(customerId: $customerId, date: $date) {
      salesforceConnectionStatus
      platformConnectionStatus
      postgresConnectionStatus
      __typename
    }
  }
`;
export const listRlsOrgAnalytics = /* GraphQL */ `
  query ListRlsOrgAnalytics(
    $customerId: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsOrgAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsOrgAnalytics(
      customerId: $customerId
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        customerId
        date
        time
        organizationId
        organizationFriendlyId
        environmentCode
        activeUsers
        inActiveUsers
        deletedUsers
        roles
        apiConnections
        customerCodes
        trustedApis
        trustedObjects
        apiResources
        objects
        categories
        schedulers
        dataSyncStatus
        environment

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listRlsOrgAnalyticsUserCount = /* GraphQL */ `
  query ListRlsOrgAnalytics(
    $customerId: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsOrgAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsOrgAnalytics(
      customerId: $customerId
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        activeUsers
        inActiveUsers
        deletedUsers
        roles
        apiConnections

        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRlsEnvAnalytics = /* GraphQL */ `
  query GetRlsEnvAnalytics($environment: String!, $date: AWSDate!) {
    getRlsEnvAnalytics(environment: $environment, date: $date) {
      id
      environment
      date
      time
      environmentCode
      activeCustomersCount
      inActiveCustomersCount
      idpCustomersCount
      nonIdpCustomersCount
      trialOrgCount
      nonTrialOrgCount
      accountsCount
      releasesCount
      licenses
      accounts
      availableShards
      __typename
    }
  }
`;

export const getRlsEnvAnalyticsShardsOnly = /* GraphQL */ `
  query GetRlsEnvAnalytics($environment: String!, $date: AWSDate!) {
    getRlsEnvAnalytics(environment: $environment, date: $date) {
      id
      date
      time
      availableShards
      __typename
    }
  }
`;

export const getRlsOrgData = /* GraphQL */ `
  query GetRlsOrgData($customerId: String!) {
    getRlsOrgData(customerId: $customerId) {
      id
      customerId
      organizationId
      organizationFriendlyId
      environmentCode
      offboardingRequested
      offboardingRequestedBy
      offboardingStatus
      environment
      __typename
    }
  }
`;

export const getRlsEnvData = /* GraphQL */ `
  query GetRlsEnvData($environment: String!) {
    getRlsEnvData(environment: $environment) {
      id
      environment
      environmentCode
      environmentSwaggerRoutes
      uiUrls
      __typename
    }
  }
`;

export const getRlsInactiveOrgs = /* GraphQL */ `
  query GetRlsEnvData($environment: String!) {
    getRlsEnvData(environment: $environment) {
      id
      environment
      environmentCode
      inactiveOrgs
      __typename
    }
  }
`;

export const listRlsEnvAnalytics = /* GraphQL */ `
  query ListRlsEnvAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        environment
        date
        time
        environmentCode
        activeCustomersCount
        inActiveCustomersCount
        idpCustomersCount
        nonIdpCustomersCount
        trialOrgCount
        nonTrialOrgCount
        accountsCount
        releasesCount
        licenses
        accounts
        availableShards

        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRlsEnvUserTotalAnalytics = /* GraphQL */ `
  query ListRlsEnvUserAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvUserAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvUserAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        environment
        date
        time
        totalUsers
        totalGuestUsers
        totalDdsConnections
        totalOneTimeUserLogin
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listRlsEnvUserTotalSummaryAnalytics = /* GraphQL */ `
  query ListRlsEnvUserAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvUserAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvUserAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        environment
        date
        time
        totalWeeklyActiveUsers
        totalMonthlyActiveUsers
        totalQuarterlyActiveUsers
        totalHalfYearlyActiveUsers
        totalActiveUsersFromLastSixMonths
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getRlsOrgUserAnalyticsByLicense = /* GraphQL */ `
  query getRlsOrgUserAnalyticsByLicenseAccountId(
    $licenseAccountId: String!
    $date: String!
    $nextToken: String
    $limit: Int!
  ) {
    rlsOrgUserAnalyticsByLicenseAccountId(
      licenseAccountId: $licenseAccountId
      filter: { date: { eq: $date } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        activeUsersFromLastSixMonths
        currentInstanceURL
        date
        ddsConnections
        environment
        guestUsers
        halfYearlyActiveUsers
        id
        lastActiveUserEmail
        lastActiveUserId
        lastActiveUserLoginDate
        lastActiveUserSignInMethod
        licenseAccountId
        licenseAccountName
        monthlyActiveUsers
        onboardingDate
        oneTimeUserLogin
        organizationFriendlyId
        organizationId
        quarterlyActiveUsers
        time
        totalUsers
        weeklyActiveUsers
      }
      nextToken
    }
  }
`;

export const listRlsEnvAnalyticsCountOnly = /* GraphQL */ `
  query ListRlsEnvAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        time
        activeCustomersCount
        inActiveCustomersCount
        idpCustomersCount
        nonIdpCustomersCount
        trialOrgCount
        nonTrialOrgCount
        accountsCount
        releasesCount

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listRlsEnvAnalyticsLicensesOnly = /* GraphQL */ `
  query ListRlsEnvAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        licenses

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listRlsEnvAnalyticsAccountsOnly = /* GraphQL */ `
  query ListRlsEnvAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        accounts

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listRlsEnvAnalyticsShardsOnly = /* GraphQL */ `
  query ListRlsEnvAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        availableShards

        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rlsOrgAnalyticsByEnvironment = /* GraphQL */ `
  query RlsOrgAnalyticsByEnvironment(
    $environment: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRlsOrgAnalyticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rlsOrgAnalyticsByEnvironment(
      environment: $environment
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        date
        time
        organizationId
        organizationFriendlyId
        environmentCode
        activeUsers
        inActiveUsers
        deletedUsers
        roles
        apiConnections
        customerCodes
        trustedApis
        trustedObjects
        apiResources
        objects
        categories
        schedulers
        dataSyncStatus
        environment

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listRlsOrgUserAnalyticsLastLogin = /* GraphQL */ `
  query ListRlsOrgUserAnalytics(
    $environment: String!
    $dateStart: String
    $dateEnd: String
    $limit: Int
    $nextToken: String
  ) {
    rlsOrgUserAnalyticsByEnvironment(
      environment: $environment
      filter: { date: { between: [$dateStart, $dateEnd] } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        organizationFriendlyId
        lastActiveUserLoginDate
        lastActiveUserEmail
        lastActiveUserSignInMethod
        totalUsers
        weeklyActiveUsers
        monthlyActiveUsers
        onboardingDate
      }
      nextToken
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      email
      firstTimeLogedIn
      firstTimeRequestedAccessControl
      accessControlApplied
    }
  }
`;
export const getUserByEmail = /* GraphQL */ `
  query GetUserByEmail($email: AWSEmail!) {
    getUserByEmail(email: $email) {
      items {
        id
        username
        email
        firstTimeLogedIn
        firstTimeRequestedAccessControl
        accessControlApplied
      }
      nextToken
    }
  }
`;

export const getAppliedAccessControl = /* GraphQL */ `
  query GetAppliedAccessControl($userId: ID!) {
    getAppliedAccessControl(userId: $userId) {
      accessDetails
      created
    }
  }
`;

export const getRequestControlByUserIdAndStatus = /* GraphQL */ `
  query GetRequestControlByUserIdAndStatus($created: Boolean!) {
    listRequestedAccessControls(filter: { created: { eq: $created } }) {
      items {
        userId
        requestDetails
        created
        user {
          id
          username
          email
          firstTimeLogedIn
          firstTimeRequestedAccessControl
          accessControlApplied
        }
      }
    }
  }
`;

export const listUsersWithCount = /* GraphQL */ `
  query ListUsersWithCount($limit: Int, $nextToken: String) {
    listUsersWithCount(limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        email
        firstTimeLogedIn
        firstTimeRequestedAccessControl
        accessControlApplied
      }
      nextToken
    }
  }
`;

export const getTotalUserCount = /* GraphQL */ `
  query GetTotalUserCount {
    getTotalUserCount
  }
`;

export const getTidbMigrationGroupQuery = /* GraphQL */ `
  query GetTidbMigrationGroup($id: ID!) {
    getTidbMigrationGroup(id: $id) {
      id
      environment
      tidbDatabaseName
      infraId
      isStandaloneDatabase
      createdAt
      createdBy
      migrationCompletedOn
      status
      notificationConfiguration {
        sendNotificationPriorToMigration
        sendNotificationAfterMigration
        sendNotificationPriorToDataValidation
        sendNotificationAfterDataValidation
        notificationUserbase
      }
      customers {
        items {
          id
          customerId
          orgFid
          orgId
          migrationStatus
          environment
          currentInstanceURL
          forceMigration
          sendNotificationPriorToMigration {
            state
            startedAt
            completedAt
          }
          sendNotificationAfterMigration {
            state
            startedAt
            completedAt
          }
          sendNotificationPriorToDataValidation {
            state
            startedAt
            completedAt
          }
          sendNotificationAfterDataValidation {
            state
            startedAt
            completedAt
          }
          datamigrationStatus {
            state
            startedAt
            completedAt
            trackingId
          }
          dataValidationAndSwitchOverStatus {
            state
            startedAt
            completedAt
            trackingId
          }
        }
      }
    }
  }
`;

export const getAllTidbMigrationGroupsAndCustomers = /* GraphQL */ `
  query ListTidbMigrationGroupsByEnv(
    $environment: String!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    tidbMigrationGroupsByEnvironmentAndCreatedAt(
      environment: $environment
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        environment
        tidbDatabaseName
        infraId
        isStandaloneDatabase
        createdAt
        updatedAt
        migrationCompletedOn
        createdBy
        status
        notificationConfiguration {
          sendNotificationPriorToMigration
          sendNotificationAfterMigration
          sendNotificationPriorToDataValidation
          sendNotificationAfterDataValidation
          notificationUserbase
        }
        customers {
          items {
            customerId
            orgFid
            orgId
            migrationStatus
            currentInstanceURL
            sendNotificationPriorToMigration {
              state
              startedAt
              completedAt
            }
            sendNotificationAfterMigration {
              state
              startedAt
              completedAt
            }
            sendNotificationPriorToDataValidation {
              state
              startedAt
              completedAt
            }
            sendNotificationAfterDataValidation {
              state
              startedAt
              completedAt
            }
            datamigrationStatus {
              state
              startedAt
              completedAt
              trackingId
            }
            dataValidationAndSwitchOverStatus {
              state
              startedAt
              completedAt
              trackingId
            }
            forceMigration
            environment
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const getAllTidbMigrationGroupsAndCustomersWithFilter = /* GraphQL */ `
  query ListTidbMigrationGroupsByEnv(
    $environment: String!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
    $filter: ModelTidbMigrationGroupFilterInput
  ) {
    tidbMigrationGroupsByEnvironmentAndCreatedAt(
      environment: $environment
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
      filter: $filter
    ) {
      items {
        id
        environment
        tidbDatabaseName
        infraId
        isStandaloneDatabase
        createdAt
        updatedAt
        migrationCompletedOn
        createdBy
        status
        notificationConfiguration {
          sendNotificationPriorToMigration
          sendNotificationAfterMigration
          sendNotificationPriorToDataValidation
          sendNotificationAfterDataValidation
          notificationUserbase
        }
        customers {
          items {
            customerId
            orgFid
            orgId
            migrationStatus
            currentInstanceURL
            sendNotificationPriorToMigration {
              state
              startedAt
              completedAt
            }
            sendNotificationAfterMigration {
              state
              startedAt
              completedAt
            }
            sendNotificationPriorToDataValidation {
              state
              startedAt
              completedAt
            }
            sendNotificationAfterDataValidation {
              state
              startedAt
              completedAt
            }
            datamigrationStatus {
              state
              startedAt
              completedAt
              trackingId
            }
            dataValidationAndSwitchOverStatus {
              state
              startedAt
              completedAt
              trackingId
            }
            forceMigration
            environment
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const getAllTidbMigrationGroupsAndCustomersWithCustomersFilter = /* GraphQL */ `
  query ListTidbMigrationGroupsByCustomerId(
    $environment: String!
    $customerId: ID!
    $limit: Int
    $nextToken: String
  ) {
    tidbMigrationCustomersByEnvironmentAndCustomerId(
      environment: $environment
      customerId: { eq: $customerId }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        group {
          id
          environment
          tidbDatabaseName
          infraId
          isStandaloneDatabase
          createdAt
          updatedAt
          migrationCompletedOn
          createdBy
          status
          notificationConfiguration {
            sendNotificationPriorToMigration
            sendNotificationAfterMigration
            sendNotificationPriorToDataValidation
            sendNotificationAfterDataValidation
            notificationUserbase
          }
          customers {
            items {
              customerId
              orgFid
              orgId
              migrationStatus
              currentInstanceURL
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const listCustomersWithCompletedValidation = /* GraphQL */ `
  query ListCustomersWithCompletedValidation(
    $filter: ModelTidbMigrationCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTidbMigrationCustomers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        orgFid
        orgId
        migrationStatus
        currentInstanceURL
        dataValidationAndSwitchOverStatus {
          state
          startedAt
          completedAt
          trackingId
        }
      }
      nextToken
    }
  }
`;

export const listTurboHealthChecks = /* GraphQL */ `
  query ListTurboHealthChecks($limit: Int, $nextToken: String) {
    listTurboHealthChecks(limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
        environmentId
        lastCheckedOn
        dataIntegrationHealthStatus
        dataAdminHealthStatus
        pricingHealthStatus
        cmsPublisherHealthStatus
        dataIntegrationHealthResponse
        dataAdminHealthResponse
        pricingHealthResponse
        cmsPublisherHealthResponse
        callVictorops
        healthCheckInterval
        disableIntegrationHealthCheck
        disableAdminHealthCheck
        disablePricingHealthCheck
        disableCmsPublisherHealthCheck
        currencyBackupLastDoneOn
        currencyBackupLastprocessedState
        currencyBackupLastprocessedMessage
        tenantSubdomain
        isMongoDBHealthy
        isMongoDBHealthyMessage
        nextDataScaleStatus
        nextPricingScaleStatus
        environmentCode
        tenantSize
        tenantType
        orgId
        lsDataReleaseVersion
        lsPricingReleaseVersion
      }
      nextToken
    }
  }
`;

export const getTurboHealthChecks = /* GraphQL */ `
  query GetTurboHealthChecks($tenantId: String!) {
    getTurboHealthChecks(tenantId: $tenantId) {
      id
      tenantId
      environmentId
      lastCheckedOn
      dataIntegrationHealthStatus
      dataAdminHealthStatus
      pricingHealthStatus
      dataIntegrationHealthResponse
      dataAdminHealthResponse
      pricingHealthResponse
      callVictorops
      healthCheckInterval
      disableIntegrationHealthCheck
      disableAdminHealthCheck
      disablePricingHealthCheck
      currencyBackupLastDoneOn
      currencyBackupLastprocessedState
      currencyBackupLastprocessedMessage
      tenantSubdomain
      nextDataScaleStatus
      nextPricingScaleStatus
      environmentCode
      tenantSize
      tenantType
      orgId
      lsDataReleaseVersion
      lsPricingReleaseVersion
    }
  }
`;

export const listTurboHealthChecksSLAMetrics = /* GraphQL */ `
  query ListTurboHealthChecksSLAMetrics(
    $tenantId: String!
    $startDate: String
    $endDate: String
  ) {
    listTurboHealthChecksSLAMetrics(
      filter: {
        tenantId: { eq: $tenantId }
        intervalType: { eq: "day" }
        intervalKey: { between: [$startDate, $endDate] }
      }
    ) {
      items {
        healthyChecks
        id
        intervalKey
        intervalType
        lastUpdated
        tenantId
        totalChecks
      }
    }
  }
`;

export const getRlsOrgUserAnalyticsByEnvDate = /* GraphQL */ `
  query GetRlsOrgUserAnalyticsByEnvDate(
    $environment: String!
    $date: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    getRlsOrgUserAnalyticsByEnvDate(
      environment: $environment
      date: $date
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        organizationFriendlyId
        lastActiveUserLoginDate
        lastActiveUserEmail
        lastActiveUserSignInMethod
        totalUsers
        weeklyActiveUsers
        monthlyActiveUsers
        onboardingDate
      }
      nextToken
    }
  }
`;

export const getRlsOrgUserAnalyticsByEnvDateForUsersData = /* GraphQL */ `
  query GetRlsOrgUserAnalyticsByEnvDate(
    $environment: String!
    $date: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    getRlsOrgUserAnalyticsByEnvDate(
      environment: $environment
      date: $date
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        oneTimeUserLogin
        totalUsers
        guestUsers
        ddsConnections
        currentInstanceURL
        date
        environment
        id
        organizationFriendlyId
        organizationId
        time
      }
      nextToken
    }
  }
`;

export const getRlsOrgUserAnalyticsByEnvDateForUsersEngagement = /* GraphQL */ `
  query GetRlsOrgUserAnalyticsByEnvDate(
    $environment: String!
    $date: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    getRlsOrgUserAnalyticsByEnvDate(
      environment: $environment
      date: $date
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        totalUsers
        weeklyActiveUsers
        quarterlyActiveUsers
        monthlyActiveUsers
        halfYearlyActiveUsers
        currentInstanceURL
        date
        environment
        id
        organizationFriendlyId
        organizationId
        time
      }
      nextToken
    }
  }
`;

export const getRlsUserBehaviorCompositeData = /* GraphQL */ `
  query GetRlsUserBehaviorCompositeData(
    $environment: String!
    $date: ModelStringKeyConditionInput
  ) {
    # Environment Summary Analytics
    listRlsEnvUserAnalytics(environment: $environment, date: $date) {
      items {
        environment
        date
        time
        totalUsers
        totalGuestUsers
        totalDdsConnections
        totalOneTimeUserLogin
        totalWeeklyActiveUsers
        totalMonthlyActiveUsers
        totalQuarterlyActiveUsers
        totalHalfYearlyActiveUsers
        totalActiveUsersFromLastSixMonths
      }
    }

    # Organization Details
    getRlsOrgUserAnalyticsByEnvDate(environment: $environment, date: $date) {
      items {
        customerId
        environment
        organizationId
        organizationFriendlyId
        currentInstanceURL
        totalUsers
        weeklyActiveUsers
        monthlyActiveUsers
        quarterlyActiveUsers
        halfYearlyActiveUsers
        oneTimeUserLogin
        guestUsers
        ddsConnections
        lastActiveUserLoginDate
        lastActiveUserEmail
        lastActiveUserSignInMethod
        onboardingDate
        licenseAccountId
        licenseAccountName
        date
        time
      }
    }
  }
`;

export const getRLSEnvPolicy = /* GraphQL */ `
  query GetRLSEnvPolicy($environmentWithPolicy: String!) {
    getRLSEnvPolicy(environmentWithPolicy: $environmentWithPolicy) {
      id
      environmentWithPolicy
      environmentCode
      environment
      unusedIngressRoutes
      checkIfSecretsAreConsumed
      checkIfConfigmapAreConsumed
      checkIfSecretKeysInDopplerIsUnused
      unusedRbacResources
      apiPodsShouldHaveMoreThanOneReplica
      imageIncludesLatestTag
      checkIfPodIsRunningOnNonRootMode
      checkIfPodIsRunningOnPrivilegedMode
      checkNetworkPolicies
      checkHealthProbes
      checkResourceQuotas
      checkStorageClassUsage
      checkPodDisruptionBudgets
      checkSecurityContext
      __typename
    }
  }
`;

export const getSignMigrationGroupQuery = /* GraphQL */ `
  query GetSignMigrationGroup($id: ID!) {
    getSignMigrationGroup(id: $id) {
      id
      environment
      forceMigration
      totalNumberOfCustomers
      groupType
      customerIndexes
      customers {
        customerId
        orgFid
        orgId
      }
      bulkMigrationTrackingId
      createdAt
    }
  }
`;

export const listSignMigrationGroupsByEnv = /* GraphQL */ `
  query ListSignMigrationGroupsByEnv(
    $environment: String!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    signMigrationGroupsByEnvironmentAndCreatedAt(
      environment: $environment
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        environment
        forceMigration
        totalNumberOfCustomers
        groupType
        customerIndexes
        customers {
          customerId
          orgFid
          orgId
        }
        bulkMigrationTrackingId
        createdAt
      }
      nextToken
    }
  }
`;

export const listRlsEnvAnalyticsOpenSearchMetrics = /* GraphQL */ `
  query ListRlsEnvAnalytics(
    $environment: String
    $date: ModelStringKeyConditionInput
    $filter: ModelRlsEnvAnalyticsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRlsEnvAnalytics(
      environment: $environment
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        environment
        date
        time
        totalIndices
        healthStats
        totalDocuments
        totalDocumentsDeleted
        totalSize
        primarySize
        formattedSize
        formattedPrimarySize
        totalPrimaryShards
        totalReplicaShards
        availableShards
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getOpenSearchMigrationGroupQuery = /* GraphQL */ `
  query GetOpenSearchMigrationGroup($id: ID!) {
    getOpenSearchMigrationGroup(id: $id) {
      id
      environment
      totalNumberOfCustomers
      groupType
      customerIndexes
      customers {
        customerId
        orgFid
        orgId
        instanceUrl
      }
      trackingId
      createdAt
      createdBy
    }
  }
`;

export const listOpenSearchMigrationGroupsByEnv = /* GraphQL */ `
  query ListOpenSearchMigrationGroupsByEnv(
    $environment: String!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    openSearchMigrationGroupsByEnvironmentAndCreatedAt(
      environment: $environment
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        environment
        totalNumberOfCustomers
        groupType
        customerIndexes
        customers {
          customerId
          orgFid
          orgId
          instanceUrl
        }
        trackingId
        createdAt
        createdBy
      }
      nextToken
    }
  }
`;

export const getOpsPortalJobTracker = /* GraphQL */ `
  query GetOpsPortalJobTracker($jobId: String!) {
    getOpsPortalJobTracker(jobId: $jobId) {
      jobId
      jobEnvironment
      jobType
      status
      createdAt
      updatedAt
      jobStageName
      allJobStages
      jobParameters
      jobName
      environment
      jobTriggeredBy {
        name
        email
      }
    }
  }
`;

export const listOpsPortalJobTrackersByEnvironment = /* GraphQL */ `
  query ListOpsPortalJobTrackersByEnvironment(
    $jobEnvironment: String!
    $sortDirection: ModelSortDirection
    $filter: ModelOpsPortalJobTrackerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpsPortalJobTrackersByEnvironment(
      jobEnvironment: $jobEnvironment
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        jobId
        jobEnvironment
        jobType
        status
        createdAt
        updatedAt
        jobStageName
        allJobStages
        jobParameters
        jobName
        environment
        jobTriggeredBy {
          name
          email
        }
      }
      nextToken
    }
  }
`;

export const listOpsPortalJobTrackersByType = /* GraphQL */ `
  query ListOpsPortalJobTrackersByType(
    $jobType: String!
    $sortDirection: ModelSortDirection
    $filter: ModelOpsPortalJobTrackerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpsPortalJobTrackersByType(
      jobType: $jobType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        jobId
        jobEnvironment
        jobType
        status
        createdAt
        updatedAt
        jobStageName
        allJobStages
        jobParameters
        jobName
        environment
        jobTriggeredBy {
          name
          email
        }
      }
      nextToken
    }
  }
`;
export const listOpsPortalJobTrackersByEnvAndJobEnv = /* GraphQL */ `
  query ListOpsPortalJobTrackersByEnvAndJobEnv(
    $environment: String!
    $jobEnvironment: String!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listOpsPortalJobTrackersByEnvAndJobEnv(
      environment: $environment
      jobEnvironment: $jobEnvironment
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        jobId
        jobEnvironment
        jobType
        status
        createdAt
        updatedAt
        jobStageName
        allJobStages
        jobParameters
        jobName
        environment
        jobTriggeredBy {
          name
          email
        }
      }
      nextToken
    }
  }
`;

export const OpsPortalJobTrackersByEnvironmentAndCreatedAt = /* GraphQL */ `
  query OpsPortalJobTrackersByEnvironmentAndCreatedAt(
    $environment: String!
    $sortDirection: ModelSortDirection
    $filter: ModelOpsPortalJobTrackerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    opsPortalJobTrackersByEnvironmentAndCreatedAt(
      environment: $environment
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        jobId
        jobEnvironment
        jobType
        status
        createdAt
        updatedAt
        jobStageName
        allJobStages
        jobParameters
        jobName
        environment
        jobTriggeredBy {
          name
          email
        }
      }
      nextToken
    }
  }
`;

export const getSlaMetricsByTenantIdAndIntervalKey = /* GraphQL */ `
  query GetSlaMetricsByTenantIdAndIntervalKey(
    $tenantId: String!
    $intervalKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    getSlaMetricsByTenantIdAndIntervalKey(
      tenantId: $tenantId
      intervalKey: $intervalKey
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantId
        intervalKey
        intervalType
        healthyChecks
        totalChecks
        lastUpdated
      }
      nextToken
    }
  }
`;

// ObjectDbCleanup related queries
export const getObjectDbCleanupExecution = /* GraphQL */ `
  query GetObjectDbCleanupExecution($id: ID!) {
    getObjectDbCleanupExecution(id: $id) {
      id
      executionId
      executionDate
      executionType
      customerId
      orgFriendlyId
      orgId
      environmentId
      status
      totalRulesCount
      completedRulesCount
      failedRulesCount
      skippedRulesCount
      totalFoldersToClean
      foldersProcessed
      foldersSkipped
      foldersErrored
      startedAt
      completedAt
      duration
      errorCount
      lastError
      errorDetails
      rulesConfigSnapshot
      createdAt
      updatedAt
      ruleExecutions {
        items {
          id
          executionId
          ruleId
          ruleName
          ruleType
          ruleVersion
          status
          itemsToProcess
          itemsProcessed
          itemsFailed
          itemsSkipped
          startedAt
          completedAt
          duration
          resultSummary
          errorMessage
          warningMessages
          ruleParameters
          affectedPaths
          throughput
          createdAt
          updatedAt
        }
        nextToken
      }
      __typename
    }
  }
`;

export const listObjectDbCleanupExecutions = /* GraphQL */ `
  query ListObjectDbCleanupExecutions(
    $filter: ModelObjectDbCleanupExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupExecutions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        executionDate
        executionType
        customerId
        orgFriendlyId
        orgId
        environmentId
        status
        totalRulesCount
        completedRulesCount
        failedRulesCount
        skippedRulesCount
        totalFoldersToClean
        foldersProcessed
        foldersSkipped
        foldersErrored
        startedAt
        completedAt
        duration
        errorCount
        lastError
        processedCustomersCount
        processedCustomers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupExecutionsByCustomerIdAndExecutionDate = /* GraphQL */ `
  query ObjectDbCleanupExecutionsByCustomerIdAndExecutionDate(
    $customerId: String!
    $executionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelObjectDbCleanupExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupExecutionsByCustomerIdAndExecutionDate(
      customerId: $customerId
      executionDate: $executionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        executionDate
        executionType
        customerId
        orgFriendlyId
        orgId
        environmentId
        status
        totalRulesCount
        completedRulesCount
        failedRulesCount
        skippedRulesCount
        totalFoldersToClean
        foldersProcessed
        foldersSkipped
        foldersErrored
        startedAt
        completedAt
        duration
        errorCount
        lastError
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupExecutionsByEnvironmentIdAndExecutionDate = /* GraphQL */ `
  query ObjectDbCleanupExecutionsByEnvironmentIdAndExecutionDate(
    $environmentId: String!
    $executionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelObjectDbCleanupExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupExecutionsByEnvironmentIdAndExecutionDate(
      environmentId: $environmentId
      executionDate: $executionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        executionDate
        executionType
        customerId
        orgFriendlyId
        orgId
        environmentId
        status
        totalRulesCount
        completedRulesCount
        failedRulesCount
        skippedRulesCount
        totalFoldersToClean
        foldersProcessed
        foldersSkipped
        foldersErrored
        startedAt
        completedAt
        duration
        errorCount
        lastError
        processedCustomersCount
        processedCustomers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getObjectDbRuleExecution = /* GraphQL */ `
  query GetObjectDbRuleExecution($id: ID!) {
    getObjectDbRuleExecution(id: $id) {
      id
      executionId
      ruleId
      ruleName
      ruleType
      ruleVersion
      status
      itemsToProcess
      itemsProcessed
      itemsFailed
      itemsSkipped
      startedAt
      completedAt
      duration
      resultSummary
      errorMessage
      warningMessages
      ruleParameters
      affectedPaths
      throughput
      createdAt
      updatedAt
      execution {
        id
        executionId
        executionDate
        executionType
        customerId
        orgFriendlyId
        orgId
        environmentId
        status
        totalRulesCount
        completedRulesCount
        failedRulesCount
        skippedRulesCount
        totalFoldersToClean
        foldersProcessed
        foldersSkipped
        foldersErrored
        startedAt
        completedAt
        duration
        errorCount
        lastError
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;

export const listObjectDbRuleExecutions = /* GraphQL */ `
  query ListObjectDbRuleExecutions(
    $filter: ModelObjectDbRuleExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbRuleExecutions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        ruleId
        ruleName
        ruleType
        ruleVersion
        status
        itemsToProcess
        itemsProcessed
        itemsFailed
        itemsSkipped
        startedAt
        completedAt
        duration
        resultSummary
        errorMessage
        warningMessages
        ruleParameters
        affectedPaths
        throughput
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbRuleExecutionsByExecutionIdAndCreatedAt = /* GraphQL */ `
  query ObjectDbRuleExecutionsByExecutionIdAndCreatedAt(
    $executionId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelObjectDbRuleExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbRuleExecutionsByExecutionIdAndCreatedAt(
      executionId: $executionId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        ruleId
        ruleName
        ruleType
        ruleVersion
        status
        itemsToProcess
        itemsProcessed
        itemsFailed
        itemsSkipped
        startedAt
        completedAt
        duration
        resultSummary
        errorMessage
        warningMessages
        ruleParameters
        affectedPaths
        throughput
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getObjectDbCleanupExecutionSummary = /* GraphQL */ `
  query GetObjectDbCleanupExecutionSummary($id: ID!) {
    getObjectDbCleanupExecutionSummary(id: $id) {
      id
      summaryType
      summaryDate
      environmentId
      customerId
      totalExecutions
      completedExecutions
      failedExecutions
      inProgressExecutions
      totalFoldersProcessed
      totalErrorsEncountered
      environmentMetrics
      customerMetrics
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const listObjectDbCleanupExecutionSummaries = /* GraphQL */ `
  query ListObjectDbCleanupExecutionSummaries(
    $filter: ModelObjectDbCleanupExecutionSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupExecutionSummaries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        summaryType
        summaryDate
        environmentId
        customerId
        totalExecutions
        completedExecutions
        failedExecutions
        inProgressExecutions
        totalFoldersProcessed
        totalErrorsEncountered
        environmentMetrics
        customerMetrics
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupExecutionSummariesBySummaryDate = /* GraphQL */ `
  query ObjectDbCleanupExecutionSummariesBySummaryDate(
    $summaryDate: AWSDate!
    $filter: ModelObjectDbCleanupExecutionSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupExecutionSummariesBySummaryDate(
      summaryDate: $summaryDate
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        summaryType
        summaryDate
        environmentId
        customerId
        totalExecutions
        completedExecutions
        failedExecutions
        inProgressExecutions
        totalFoldersProcessed
        totalErrorsEncountered
        environmentMetrics
        customerMetrics
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupExecutionSummariesByEnvironmentIdAndSummaryDate = /* GraphQL */ `
  query ObjectDbCleanupExecutionSummariesByEnvironmentIdAndSummaryDate(
    $environmentId: String!
    $summaryDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelObjectDbCleanupExecutionSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupExecutionSummariesByEnvironmentIdAndSummaryDate(
      environmentId: $environmentId
      summaryDate: $summaryDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        summaryType
        summaryDate
        environmentId
        customerId
        totalExecutions
        completedExecutions
        failedExecutions
        inProgressExecutions
        totalFoldersProcessed
        totalErrorsEncountered
        environmentMetrics
        customerMetrics
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupExecutionSummariesByCustomerIdAndSummaryDate = /* GraphQL */ `
  query ObjectDbCleanupExecutionSummariesByCustomerIdAndSummaryDate(
    $customerId: String!
    $summaryDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelObjectDbCleanupExecutionSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupExecutionSummariesByCustomerIdAndSummaryDate(
      customerId: $customerId
      summaryDate: $summaryDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        summaryType
        summaryDate
        environmentId
        customerId
        totalExecutions
        completedExecutions
        failedExecutions
        inProgressExecutions
        totalFoldersProcessed
        totalErrorsEncountered
        environmentMetrics
        customerMetrics
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getObjectDbCleanupRuleStatus = /* GraphQL */ `
  query GetObjectDbCleanupRuleStatus($id: ID!) {
    getObjectDbCleanupRuleStatus(id: $id) {
      id
      ruleId
      customerId
      orgFriendlyId
      orgId
      environmentId
      ruleName
      ruleType
      ruleVersion
      ruleDescription
      ruleConfiguration
      status
      isActive
      targetPath
      targetFolderExists
      lastFolderCheckTime
      scheduleExpression
      nextScheduledRun
      lastExecutionId
      lastExecutionTime
      lastExecutionStatus
      markedForDeletion
      deletionReason
      deletionScheduledTime
      deletionCompletedTime
      totalExecutions
      successfulExecutions
      failedExecutions
      lastSuccessfulExecution
      createdBy
      createdAt
      updatedAt
      deletedAt
      __typename
    }
  }
`;

export const listObjectDbCleanupRuleStatuses = /* GraphQL */ `
  query ListObjectDbCleanupRuleStatuses(
    $filter: ModelObjectDbCleanupRuleStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupRuleStatuses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        customerId
        orgFriendlyId
        orgId
        environmentId
        ruleName
        ruleType
        ruleVersion
        ruleDescription
        ruleConfiguration
        status
        isActive
        targetPath
        targetFolderExists
        lastFolderCheckTime
        scheduleExpression
        nextScheduledRun
        lastExecutionId
        lastExecutionTime
        lastExecutionStatus
        markedForDeletion
        deletionReason
        deletionScheduledTime
        deletionCompletedTime
        totalExecutions
        successfulExecutions
        failedExecutions
        lastSuccessfulExecution
        createdBy
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupRuleStatusesByRuleId = /* GraphQL */ `
  query ObjectDbCleanupRuleStatusesByRuleId(
    $ruleId: String!
    $filter: ModelObjectDbCleanupRuleStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupRuleStatusesByRuleId(
      ruleId: $ruleId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        customerId
        orgFriendlyId
        orgId
        environmentId
        ruleName
        ruleType
        ruleVersion
        ruleDescription
        ruleConfiguration
        status
        isActive
        targetPath
        targetFolderExists
        lastFolderCheckTime
        scheduleExpression
        nextScheduledRun
        lastExecutionId
        lastExecutionTime
        lastExecutionStatus
        markedForDeletion
        deletionReason
        deletionScheduledTime
        deletionCompletedTime
        totalExecutions
        successfulExecutions
        failedExecutions
        lastSuccessfulExecution
        createdBy
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupRuleStatusesByCustomerId = /* GraphQL */ `
  query ObjectDbCleanupRuleStatusesByCustomerId(
    $customerId: String!
    $filter: ModelObjectDbCleanupRuleStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupRuleStatusesByCustomerId(
      customerId: $customerId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        customerId
        orgFriendlyId
        orgId
        environmentId
        ruleName
        ruleType
        ruleVersion
        ruleDescription
        ruleConfiguration
        status
        isActive
        targetPath
        targetFolderExists
        lastFolderCheckTime
        scheduleExpression
        nextScheduledRun
        lastExecutionId
        lastExecutionTime
        lastExecutionStatus
        markedForDeletion
        deletionReason
        deletionScheduledTime
        deletionCompletedTime
        totalExecutions
        successfulExecutions
        failedExecutions
        lastSuccessfulExecution
        createdBy
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const objectDbCleanupRuleStatusesByEnvironmentId = /* GraphQL */ `
  query ObjectDbCleanupRuleStatusesByEnvironmentId(
    $environmentId: String!
    $filter: ModelObjectDbCleanupRuleStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectDbCleanupRuleStatusesByEnvironmentId(
      environmentId: $environmentId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        customerId
        orgFriendlyId
        orgId
        environmentId
        ruleName
        ruleType
        ruleVersion
        ruleDescription
        ruleConfiguration
        status
        isActive
        targetPath
        targetFolderExists
        lastFolderCheckTime
        scheduleExpression
        nextScheduledRun
        lastExecutionId
        lastExecutionTime
        lastExecutionStatus
        markedForDeletion
        deletionReason
        deletionScheduledTime
        deletionCompletedTime
        totalExecutions
        successfulExecutions
        failedExecutions
        lastSuccessfulExecution
        createdBy
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

// Specialized ObjectDbCleanup queries
export const getActiveObjectDbCleanupExecutions = /* GraphQL */ `
  query GetActiveObjectDbCleanupExecutions(
    $filter: ModelObjectDbCleanupExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupExecutions(
      filter: {
        and: [
          $filter
          {
            or: [
              { status: { eq: "PENDING" } }
              { status: { eq: "IN_PROGRESS" } }
            ]
          }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        executionDate
        executionType
        customerId
        orgFriendlyId
        orgId
        environmentId
        status
        totalRulesCount
        completedRulesCount
        failedRulesCount
        skippedRulesCount
        totalFoldersToClean
        foldersProcessed
        foldersSkipped
        foldersErrored
        startedAt
        completedAt
        duration
        errorCount
        lastError
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getFailedObjectDbCleanupExecutions = /* GraphQL */ `
  query GetFailedObjectDbCleanupExecutions(
    $filter: ModelObjectDbCleanupExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupExecutions(
      filter: {
        and: [
          $filter
          { or: [{ status: { eq: "FAILED" } }, { status: { eq: "PARTIAL" } }] }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        executionId
        executionDate
        executionType
        customerId
        orgFriendlyId
        orgId
        environmentId
        status
        totalRulesCount
        completedRulesCount
        failedRulesCount
        skippedRulesCount
        totalFoldersToClean
        foldersProcessed
        foldersSkipped
        foldersErrored
        startedAt
        completedAt
        duration
        errorCount
        lastError
        errorDetails
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getActiveObjectDbCleanupRules = /* GraphQL */ `
  query GetActiveObjectDbCleanupRules(
    $filter: ModelObjectDbCleanupRuleStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupRuleStatuses(
      filter: {
        and: [
          $filter
          { isActive: { eq: true } }
          { markedForDeletion: { eq: false } }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        customerId
        orgFriendlyId
        orgId
        environmentId
        ruleName
        ruleType
        ruleVersion
        ruleDescription
        status
        isActive
        targetPath
        targetFolderExists
        lastFolderCheckTime
        scheduleExpression
        nextScheduledRun
        lastExecutionId
        lastExecutionTime
        lastExecutionStatus
        totalExecutions
        successfulExecutions
        failedExecutions
        lastSuccessfulExecution
        createdBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getObjectDbCleanupRulesScheduledForDeletion = /* GraphQL */ `
  query GetObjectDbCleanupRulesScheduledForDeletion(
    $filter: ModelObjectDbCleanupRuleStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectDbCleanupRuleStatuses(
      filter: {
        and: [
          $filter
          { markedForDeletion: { eq: true } }
          { status: { eq: "SCHEDULED_FOR_DELETION" } }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        customerId
        orgFriendlyId
        orgId
        environmentId
        ruleName
        ruleType
        ruleVersion
        ruleDescription
        status
        isActive
        targetPath
        targetFolderExists
        markedForDeletion
        deletionReason
        deletionScheduledTime
        deletionCompletedTime
        totalExecutions
        successfulExecutions
        failedExecutions
        lastSuccessfulExecution
        createdBy
        createdAt
        updatedAt
        deletedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
